import { useEffect } from "react";
import { useRouteLoaderData } from "react-router-dom";
import { User } from "../services/user/userModel";
import {
  hideCrisp,
  loadCrisp,
  setCrispUser,
  showCrisp,
} from "../services/crispService";

/**
 * Mounts the Crisp chatbox on the logged-in areas only. The client is a
 * page-wide singleton, so leaving those areas hides the bubble instead of
 * unloading it.
 */
const CrispChat = () => {
  const { loggedUser } = (useRouteLoaderData("logged-user") ?? {}) as {
    loggedUser?: User;
  };

  useEffect(() => {
    loadCrisp();
    showCrisp();
    return hideCrisp;
  }, []);

  useEffect(() => {
    if (loggedUser) setCrispUser(loggedUser);
  }, [loggedUser]);

  return null;
};

export default CrispChat;
